import { useState } from 'react';
import { Button } from '../../components/ui/button';
import { Textarea } from '../../components/ui/textarea';
import { Copy } from 'lucide-react';
import { toast } from 'sonner';

const MarkdownToHtmlTool = () => {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');

  const convert = () => {
    if (!input.trim()) {
      toast.error('Please enter Markdown to convert');
      return;
    }

    let html = input
      // Headers
      .replace(/^### (.*$)/gim, '<h3>$1</h3>')
      .replace(/^## (.*$)/gim, '<h2>$1</h2>')
      .replace(/^# (.*$)/gim, '<h1>$1</h1>')
      // Bold
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      .replace(/__(.*?)__/g, '<strong>$1</strong>')
      // Italic
      .replace(/\*(.*?)\*/g, '<em>$1</em>')
      .replace(/_(.*?)_/g, '<em>$1</em>')
      // Code blocks
      .replace(/```([\s\S]*?)```/g, '<pre><code>$1</code></pre>')
      // Inline code
      .replace(/`(.*?)`/g, '<code>$1</code>')
      // Links
      .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>')
      // Images
      .replace(/!\[([^\]]*)\]\(([^)]+)\)/g, '<img src="$2" alt="$1" />')
      // Unordered lists
      .replace(/^\* (.*$)/gim, '<li>$1</li>')
      .replace(/^- (.*$)/gim, '<li>$1</li>')
      // Ordered lists
      .replace(/^\d+\. (.*$)/gim, '<li>$1</li>')
      // Blockquotes
      .replace(/^> (.*$)/gim, '<blockquote>$1</blockquote>')
      // Horizontal rules
      .replace(/^---$/gim, '<hr />')
      // Line breaks
      .replace(/\n/g, '<br />');

    // Wrap consecutive li elements in ul
    html = html.replace(/(<li>.*?<\/li>)(<br \/>)?(<li>)/g, '$1$3');
    html = html.replace(/(<li>.*<\/li>)/g, '<ul>$1</ul>');
    // Clean up multiple br tags
    html = html.replace(/(<br \/>){2,}/g, '<br /><br />');

    setOutput(html);
    toast.success('Converted to HTML!');
  };

  const copyOutput = () => {
    if (output) {
      navigator.clipboard.writeText(output);
      toast.success('Copied!');
    }
  };

  return (
    <div className="space-y-4" data-testid="markdown-to-html-tool">
      <div className="flex justify-between items-center">
        <h3 className="font-semibold">Markdown to HTML</h3>
      </div>

      <Textarea
        placeholder="# Enter your Markdown here...&#10;&#10;**Bold text** and *italic text*&#10;&#10;- List item 1&#10;- List item 2"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        className="min-h-[150px] bg-background/50 font-mono text-sm"
        data-testid="input"
      />

      <Button onClick={convert} className="w-full" data-testid="convert-btn">
        Convert to HTML
      </Button>

      {output && (
        <div className="space-y-2">
          <div className="flex justify-between items-center">
            <span className="text-sm text-muted-foreground">HTML Output</span>
            <Button variant="ghost" size="sm" onClick={copyOutput}>
              <Copy className="w-4 h-4 mr-1" /> Copy
            </Button>
          </div>
          <Textarea
            value={output}
            readOnly
            className="min-h-[120px] bg-background/50 font-mono text-sm"
            data-testid="output"
          />
          <div className="p-4 rounded-lg bg-background/50 border border-border">
            <span className="text-xs text-muted-foreground mb-2 block">Preview:</span>
            <div 
              className="prose prose-invert prose-sm max-w-none"
              dangerouslySetInnerHTML={{ __html: output }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default MarkdownToHtmlTool;
